<template>
    <li class="nav-item dropdown dropdown-cart mr-25">
        <a class="nav-link cart-toggle" href="javascript:void(0);" data-toggle="dropdown">
            <vue-feather type="shopping-cart" class="ficon" />
            <span class="badge badge-pill badge-warning badge-up cart-item-count">
                {{ this.AuthenticatedUserCheckoutStore.cartItems.length }}
            </span>
        </a>
        <ul class="dropdown-menu dropdown-menu-media dropdown-menu-right">
            <li class="dropdown-menu-header">
                <div class="dropdown-header d-flex">
                    <h4 class="notification-title mb-0 mr-auto">
                        My Cart
                    </h4>
                    <div class="badge badge-pill badge-light-primary">
                        {{ this.AuthenticatedUserCheckoutStore.cartItems.length }} Items
                    </div>
                </div>
            </li>
            <li
                class="scrollable-container media-list"
            >
                <div v-for="item in this.AuthenticatedUserCheckoutStore.cartItems" class="media align-items-center">
                    <img class="d-block rounded mr-1" :src="item.image.replace('50x50', '100x100')" alt="donuts" width="62">
                    <div class="media-body">
                        <span @click="remove(item)">
                            <i class="ficon cart-item-remove" data-feather="x"></i>
                        </span>
                        <div class="media-heading">
                            <h6 class="cart-item-title">
                                {{ item.bank_name }}
                            </h6>
                        </div>
                        <h5 class="cart-item-price">
                            ${{ item.price }}
                        </h5>
                    </div>
                </div>
            </li>
            <li class="dropdown-menu-footer">
                <div class="d-flex justify-content-between mb-1">
                    <h6 class="font-weight-bolder mb-0">Total:</h6>
                    <h6 class="text-primary font-weight-bolder mb-0">
                        {{ this.AuthenticatedUserCheckoutStore.total }}
                    </h6>
                </div>
                <a
                    class="btn btn-primary btn-block"
                    @click="checkout"
                >
                    Checkout
                </a>
            </li>
        </ul>
    </li>
</template>
<style>
.cropper {
    height: 600px;
    width: 600px;
    background: #DDD;
}
</style>
<script>
    import { reactive, ref, computed } from 'vue'
    import { useAuthenticatedUserCheckoutStore } from '../stores/AuthenticatedUserCheckoutStore.js'
    import { useLocalizationStore } from '../stores/LocalizationStore.js'
    import { fix, subtract } from 'mathjs'
    export default {
        components: {
        },
        setup(props) {
            return {
                AuthenticatedUserCheckoutStore: useAuthenticatedUserCheckoutStore(),
                localizationStore: useLocalizationStore()
            }
        },
        mounted()
        {
        },
        watch: {
        },
        methods: {
            remove : function (item)
            {
                (this.AuthenticatedUserCheckoutStore.cartItems).splice((this.AuthenticatedUserCheckoutStore.cartItems).indexOf(item), 1);
                this.AuthenticatedUserCheckoutStore.total = fix(subtract(this.AuthenticatedUserCheckoutStore.total, item.price), 2);
            },
            checkout() {
                $('.cart-toggle').parent().removeClass("show");
                $('.cart-toggle').next().removeClass("show");
                if (this.AuthenticatedUserCheckoutStore.cartItems.length == 0) {
                    toastr.error(this.localizationStore.translate("cart.empty.error.message"), 'Error!');
                    return;
                }
                this.AuthenticatedUserCheckoutStore.checkoutIsActive = 1;
                document.querySelector(".content-detached").classList.remove("content-detached", "content-right");
            }
        },
        computed: {
        }
    }
</script>